<script lang="ts">
    import { onMount } from 'svelte/internal'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import FormV2SignReportPrint from '../customer-service-v2/forms/form-v2-sign-report-print.svelte'
    import type { FormV2Form } from '../../modules/toolsApi/forms-v2/form-v2-forms/form-v2-form'
    import type { FormV2FormSignature } from '../../modules/toolsApi/forms-v2/form-v2-form-signatures/form-v2-form-signature'
    import type { FormV2FormSignatureLog } from '../../modules/toolsApi/forms-v2/form-v2-signature-logs/form-v2-form-signature-log'

    // Página pública dedicada à renderização em PDF do relatório de assinaturas, consumida pela
    // lambda-pdf — mesmo padrão de form-v2-print-page.svelte (link de vida curta, linkId/token crus).
    let show = true
    let error = ''
    let form: FormV2Form | null = null
    let signers: FormV2FormSignature[] = []
    let logs: FormV2FormSignatureLog[] = []

    onMount(load)

    async function load() {
        try {
            show = true
            const urlParams = new URLSearchParams(window.location.search)
            const linkId = urlParams.get('linkId')
            // "t", não "token": ver form-v2-form-fill.svelte para o motivo.
            const token = urlParams.get('t')
            if (!linkId || !token) {
                error = 'Link inválido.'
                return
            }
            const result = await window.api.tools.formsV2.forms.publicGetSignatureReport(linkId, token)
            form = result.form
            signers = result.signers
            logs = result.logs
        } catch (err) {
            error = 'Este link não está mais disponível.'
        } finally {
            show = false
        }
    }
</script>

<div class="root">
    <LoadSpinner {show} />
    {#if error}
        <div class="msg">{error}</div>
    {:else if form}
        <FormV2SignReportPrint {form} {signers} {logs} />
    {/if}
</div>

<style>
    .root {
        min-height: 100vh;
        background: #fff;
        padding: 16px;
    }
    .msg {
        max-width: 1000px;
        margin: 40px auto;
        text-align: center;
        color: #495057;
    }
</style>
